import React, { Component } from "react";
import Flippy, { FrontSide, BackSide } from 'react-flippy';
import solvente from '../../assets/images/solvente.png';
import avanza from '../../assets/images/avanza.png';
import documentos from '../../assets/images/documentos.png';
import formulario from '../../assets/images/formulario.png';
import aranceles from '../../assets/images/aranceles.png';
import './Cards.css';
import FormReingresoMovil from '../FormReingresoMovil/FormReingresoMovil';
import { MDBRow, MDBCol } from "mdbreact";

class Cards extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="contenedorCards">

                    <div className="cajaTituloCards">
                        <h1 className="tituloCondiciones">
                            <p>REQUISITOS PARA</p>
                            <p className="futuraBold subTitulo">REINGRESO EN LÍNEA</p>
                        </h1>
                    </div>

                    <MDBRow className="cajaCards">

                        <MDBCol size="1" sm="1" md="1" lg="1" xl="1" className="marginTopCardMovil cardHideMovil">
                        </MDBCol>

                        <MDBCol size="12" sm="12" md="12" lg="2" xl="2" className="marginTopCardMovil">
                            <center>
                                <Flippy
                                    flipOnHover={true}
                                    flipDirection="vertical"
                                    flipOnClick={true}
                                    ref={(r) => this.flippy = r}
                                    className="flip"
                                    style={{ width: '200px', height: '220px' }}
                                >
                                    <FrontSide className="cuadro1">
                                        <img src={solvente} className="iconoCard" />
                                        <div className="futuraBold tituloCard">
                                            DEBES ESTAR SOLVENTE
                                        </div>
                                    </FrontSide>
                                    <BackSide
                                        className="backSide">
                                        <div className="textoBackSide contenedorCenterVertical">
                                            Para realizar tu proceso de reingreso, debes estar solvente de pagos del último ciclo cursado en la UFG.
                                        </div>
                                    </BackSide>
                                </Flippy>
                            </center>
                        </MDBCol>

                        <MDBCol size="12" sm="12" md="12" lg="2" xl="2" className="marginTopCardMovil">
                            <center>
                                <Flippy
                                    flipOnHover={true}
                                    flipDirection="vertical"
                                    flipOnClick={true}
                                    ref={(r) => this.flippy = r}
                                    style={{ width: '200px', height: '220px' }}
                                >
                                    <FrontSide className="cuadro2">
                                        <img src={avanza} className="iconoCard" />
                                        <div className="futuraBold tituloCard">
                                            PROGRAMA ACP/AVANZA
                                        </div>
                                    </FrontSide>
                                    <BackSide
                                        className="backSide">
                                        <div className="textoBackSide font11 contenedorCenterVertical">
                                            Si perteneces al Programa ACP ó Avanza, primero comunícate con Lcda. Veronica Monge al correo vmonge@ufg.edu.sv, quien te brindará la asesoria acerca de tu estado con el
                                            programa según contrato y el proceso a completar para tu reingreso.
                                        </div>
                                    </BackSide>
                                </Flippy>
                            </center>
                        </MDBCol>

                        <MDBCol size="12" sm="12" md="12" lg="2" xl="2" className="marginTopCardMovil">
                            <center>
                                <Flippy
                                    flipOnHover={true}
                                    flipDirection="vertical"
                                    flipOnClick={true}
                                    ref={(r) => this.flippy = r}
                                    style={{ width: '200px', height: '220px' }}
                                >
                                    <FrontSide className="cuadro4">
                                        <img src={formulario} className="iconoCard" />
                                        <div className="futuraBold tituloCard">
                                            COMPLETA EL FORMULARIO
                                        </div>
                                    </FrontSide>
                                    <BackSide
                                        className="backSide">
                                        <div className="textoBackSide contenedorCenterVertical">
                                            Para iniciar el proceso de reingreso, haz clic en el botón INICIAR y completa el formulario.
                                        </div>
                                    </BackSide>
                                </Flippy>
                            </center>
                        </MDBCol>

                        <MDBCol size="12" sm="12" md="12" lg="2" xl="2" className="marginTopCardMovil">
                            <center>
                                <Flippy
                                    flipOnHover={true}
                                    flipDirection="vertical"
                                    flipOnClick={true}
                                    ref={(r) => this.flippy = r}
                                    style={{ width: '200px', height: '220px' }}
                                >
                                    <FrontSide className="cuadro3">
                                        <img src={documentos} className="iconoCard" />
                                        <div className="futuraBold tituloCard">
                                            ACTUALIZA TUS DOCUMENTOS
                                        </div>
                                    </FrontSide>
                                    <BackSide
                                        className="backSide">
                                        <div className="textoBackSide contenedorCenterVertical">
                                            Si tienes más de 5 años de inactividad, envía tus documentos en formato digital.
                                        </div>
                                    </BackSide>
                                </Flippy>
                            </center>
                        </MDBCol>

                        <MDBCol size="12" sm="12" md="12" lg="2" xl="2" className="marginTopCardMovil">
                            <center>
                                <Flippy
                                    flipOnHover={true}
                                    flipDirection="vertical"
                                    flipOnClick={true}
                                    ref={(r) => this.flippy = r}
                                    style={{ width: '200px', height: '220px' }}
                                >
                                    <FrontSide className="cuadro5">
                                        <img src={aranceles} className="iconoCard" />
                                        <div className="futuraBold tituloCard">
                                            CANCELA LOS ARANCELES
                                        </div>
                                    </FrontSide>
                                    <BackSide
                                        className="backSide">
                                        <div className="textoBackSide contenedorCenterVertical">
                                            Al finalizar tu trámite de reingreso, no olvides cancelar el arancel correspondiente que se generará en tu talonario virtual.
                                        </div>
                                    </BackSide>
                                </Flippy>
                            </center>
                        </MDBCol>
                    </MDBRow>
                </div>
                <FormReingresoMovil></FormReingresoMovil>
            </React.Fragment>
        );
    }
}
export default Cards;